export const iconFontAwesomeChildhoodPuzzlePiece = (
	<i className="fa-solid fa-puzzle-piece"></i>
);
